import { render, staticRenderFns } from "./ReservationListLegacy.vue?vue&type=template&id=0776bf48&scoped=true"
import script from "./ReservationListLegacy.vue?vue&type=script&lang=js"
export * from "./ReservationListLegacy.vue?vue&type=script&lang=js"
import style0 from "./ReservationListLegacy.vue?vue&type=style&index=0&id=0776bf48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0776bf48",
  null
  
)

export default component.exports